import {setCityDirection} from '../i18n';
import { cityLocale } from "../i18n";
import type { HouseData } from "../api/types";

const LABELS: Record<string, string> = {
  technology: "فناوری",
  fashion: "مد و پوشاک",
  food: "غذا و نوشیدنی",
  services: "خدمات",
  entertainment: "سرگرمی",
  business: "کسب‌وکار",
};

export class StoreDirectory {
  private readonly root = document.createElement("div");
  private readonly list = document.createElement("div");
  private readonly input = document.createElement("input");
  private district = "all";

  constructor(
    private readonly houses: HouseData[],
    private readonly onFocus: (house: HouseData) => void,
  ) {
    this.root.className = "city-modal city-directory";setCityDirection(this.root);
    this.root.hidden = true;

    const panel = document.createElement("section");
    panel.className = "city-modal__panel city-directory__panel";

    const header = document.createElement("header");
    header.className = "city-modal__header";
    const heading = document.createElement("div");
    heading.innerHTML =
      `<strong>فهرست فروشگاه‌ها</strong><small>${houses.length.toLocaleString(cityLocale())} کسب‌وکار</small>`;
    const close = document.createElement("button");
    close.type = "button";
    close.className = "city-modal__close";
    close.textContent = "×";
    close.addEventListener("click", () => this.close());
    header.append(heading, close);

    const controls = document.createElement("div");
    controls.className = "city-directory__controls";
    this.input.type = "search";
    this.input.placeholder = "جستجوی نام، مالک یا محله…";
    this.input.addEventListener("input", () => this.render());

    const select = document.createElement("select");
    const districts = Array.from(
      new Set(houses.map((house) => house.district).filter(Boolean)),
    ) as string[];
    [["all", "همه دسته‌ها"], ...districts.map((item) => [item, LABELS[item] ?? item])]
      .forEach(([value, label]) => {
        const option = document.createElement("option");
        option.value = value;
        option.textContent = label;
        select.appendChild(option);
      });
    select.addEventListener("change", () => {
      this.district = select.value;
      this.render();
    });
    controls.append(this.input, select);

    this.list.className = "city-directory__list";
    panel.append(header, controls, this.list);
    this.root.appendChild(panel);
    document.body.appendChild(this.root);
    this.root.addEventListener("pointerdown", (event) => {
      if (event.target === this.root) this.close();
    });
  }

  open(): void {
    this.root.hidden = false;
    document.body.classList.add("city-modal-open");
    this.render();
    window.setTimeout(() => this.input.focus(), 0);
  }

  close(): void {
    this.root.hidden = true;
    document.body.classList.remove("city-modal-open");
  }

  destroy(): void {
    this.root.remove();
  }

  private render(): void {
    const needle = this.input.value.trim().toLocaleLowerCase();
    const results = this.houses.filter((house) => {
      const districtMatches =
        this.district === "all" || house.district === this.district;
      const text = [
        house.businessName,
        house.ownerName ?? "",
        house.district ?? "",
      ].join(" ").toLocaleLowerCase();
      return districtMatches && (!needle || text.includes(needle));
    });

    this.list.replaceChildren();
    if (!results.length) {
      this.list.innerHTML = '<p class="city-empty">نتیجه‌ای پیدا نشد.</p>';
      return;
    }

    for (const house of results) {
      const row = document.createElement("article");
      row.className = "city-directory__item";
      const mark = document.createElement("span");
      mark.className = "city-directory__mark";
      mark.textContent = house.businessName.slice(0, 2).toUpperCase();

      const body = document.createElement("div");
      const name = document.createElement("strong");
      name.textContent = house.businessName;
      const meta = document.createElement("small");
      meta.textContent = [
        LABELS[house.district ?? ""] ?? house.district ?? "سایر",
        house.ownerName ?? "",
      ].filter(Boolean).join(" · ");
      body.append(name, meta);

      const focus = document.createElement("button");
      focus.type = "button";
      focus.className = "city-btn";
      focus.textContent = "نمایش روی نقشه";
      focus.addEventListener("click", () => {
        this.close();
        this.onFocus(house);
      });

      row.append(mark, body, focus);
      this.list.appendChild(row);
    }
  }
}
